module.exports = __webpack_public_path__ + "img/trash-can.6b1ee7ad.svg";